import React from 'react';
import { Text, Card } from '@smarterservices/smarter-ui';
import { List } from '@instructure/ui';
import { getStore } from '../../../stores/StoreContext';
import DisplayTime from '../../Common/DisplayTime';
import ShortenSid from '../../Common/ShortenSid';
import LabelAndText from '../../Common/LabelAndText';
import CopyValue from '../../Common/CopyValue';
import CONSTANTS from '../../../config/constants';
const ExamDetails = (props) => {
  const ExamSession = getStore('examSessionStore');
  return (
    <Card {...props}>
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Exam Details
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        <List isUnstyled itemSpacing={CONSTANTS.STYLES.CARD_ITEM_SPACING}>
          <List.Item>
            <LabelAndText
              label="Id"
              text={
                <ShortenSid
                  sid={ExamSession.sessionData?.sid}
                  allowCopy={true}
                />
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Status"
              text={ExamSession.sessionData?.status}
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Title"
              text={ExamSession.sessionData?.exam?.title}
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Type"
              text={ExamSession.sessionData?.exam?.type}
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Exam Url"
              text={
                <>
                  {ExamSession.sessionData?.exam?.url}
                  <CopyValue text={ExamSession.sessionData?.exam?.url} />
                </>
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Password"
              text={
                <>
                  {ExamSession.getUniqueExamPassword()}
                  <CopyValue text={ExamSession.getUniqueExamPassword()} />
                </>
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Is Accommodation"
              text={
                ExamSession.sessionData?.examConfiguration?.type ===
                  'accommodation'
                  ? 'Yes'
                  : 'No'
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Attempts Remaining"
              text={
                ExamSession.sessionData?.examConfiguration?.attemptsRemaining +
                ' of ' +
                ExamSession.sessionData?.examConfiguration?.attempts
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Duration"
              text={
                ExamSession.sessionData?.examConfiguration?.duration +
                ' minutes'
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Exam Window"
              text={
                <>
                  <DisplayTime
                    date={
                      ExamSession.sessionData?.examConfiguration?.examOpenDate
                    }
                    tz={ExamSession.userData?.timezone?.name}
                  />{' '}
                  to{' '}
                  <DisplayTime
                    date={
                      ExamSession.sessionData?.examConfiguration?.examCloseDate
                    }
                    tz={ExamSession.userData?.timezone?.name}
                  />
                </>
              }
            />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Scheduling Window"
              text={
                <>
                  <DisplayTime
                    date={
                      ExamSession.sessionData?.examConfiguration
                        .schedulingOpenDate
                    }
                    tz={ExamSession.userData?.timezone?.name}
                  />{' '}
                  to{' '}
                  <DisplayTime
                    date={
                      ExamSession.sessionData?.examConfiguration
                        .schedulingCloseDate
                    }
                    tz={ExamSession.userData?.timezone?.name}
                  />
                </>
              }
            />
          </List.Item>
        </List>
      </Card.Body>
    </Card>
  );
};

export default ExamDetails;
